import { render, staticRenderFns } from "./NotModule.vue?vue&type=template&id=65d27e1d&scoped=true&"
import script from "./NotModule.vue?vue&type=script&lang=js&"
export * from "./NotModule.vue?vue&type=script&lang=js&"
import style0 from "./NotModule.vue?vue&type=style&index=0&id=65d27e1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d27e1d",
  null
  
)

export default component.exports